module.exports = __webpack_public_path__ + "assets/img/00069.6d8458e5.png";